const L1Categories = {
  L1CategoryList: {
    mcom: {
      categoryIds: [
        '3536',
        '118',
        '5991',
        '544',
        '26846',
        '13247',
        '30599',
        '290756',
        '168970',
        '173142',
        '339018',
        '60983',
        '29391',
        '7495',
        '16908',
        '7497',
        '1',
        '187458',
        '341648',
        '138942',
        '97743',
        '188671',
        '45269',
        '20919',
        '60241',
        '291559',
        '245256',
        '290059',
        '261156',
        '208664',
        '62204',
        '341672',
        '341722',
      ],
    },
    bcom: {
      categoryIds: [],
    },
  },
};
export default L1Categories;
